module.exports = require('./helpers/bundle-url').getBundleURL('19kb1') + "logo.7718c6df.svg";